import CandidateRequirement from './CandidateRequirement.component';

export default CandidateRequirement;